import React, { useEffect, useState } from 'react'
import Navbar from '../../appShell/Navbar/Navbar'
import Sidebar from '../../appShell/Sidebar/Sidebar'
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Navigate, useNavigate } from 'react-router-dom';
import { handleMenuSelection, handleSubMenuSelection } from '../../utils/utils';
import CustomDatatableSuiviTaux from '../../components/CustomDatatableSuiviTaux/CustomDatatableSuiviTaux';
import { FiFilter } from "react-icons/fi"
import { ImMakeGroup } from "react-icons/im"
import { FaClipboardList } from "react-icons/fa"
import CustomDatatableJournal from '../../components/CustomDatatableJournal/CustomDatatableJournal';
import { getLogs, getLogsAndParams } from '../../services/http';
import Select from 'react-select';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fr from 'date-fns/locale/fr';
import Loader from '../../components/Loader/Loader';


const Journal = () => {


    const dispatch = useDispatch();
    const [pageNumber, setPageNumber] = useState(1);
    const [perPage, setPerPage] = useState(15);
    const [totalPage, setTotalPage] = useState(1);

    const states = useSelector((state) => state, shallowEqual);
    registerLocale('fr', fr)
    const navigate = useNavigate();
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;

    const [users, setUsers] = useState([]);
    const [institutions, setInstitutions] = useState([]);
    const [displayLoader, setDisplayLoader] = useState(true);


    const [logParams, setLogParams] = useState({ user: { value: "", label: "" }, action: { value: "", label: "" }, institution: { value: "", label: "" } })


    const actions = [
        { value: "all", label: "Toutes" },
        { value: "crée", label: "Création" },
        { value: "modifié", label: "Modification" },
        { value: "supprimé", label: "Suppression" },
    ]

    // To populate the breadcrumb and update the sidebar menu
    useEffect(async () => {
        dispatch({
            type: "SET",
            key: "breadcrumbContent",
            payload: {
                firstLevelText: "Paramètres", firstLevelLink: "", secondLevelText: "Journal des évènements", secondLevelLink: "/logs", thirdLevelText: "", thirdLevelLink: ""
            }
        });
        handleMenuSelection("settings", dispatch, states);
        handleSubMenuSelection("logs", dispatch)
    }, [])
    const handleChangeEntry = () => {

    }

    const customStyles = {
        control: (provided, state) => ({
          ...provided,
          background: '#fff',
          borderColor: '#9e9e9e',
          minHeight: '35px',
          height: '35px',
          boxShadow: state.isFocused ? null : null,
        }),
    
        valueContainer: (provided, state) => ({
          ...provided,
          height: '35px',
          padding: '0 6px',
          marginTop: '-5px'
        }),
    
        input: (provided, state) => ({
          ...provided,
          margin: '0px',
        }),
        indicatorSeparator: state => ({
          display: 'none',
        //   height: '30px'
        }),
        indicatorsContainer: (provided, state) => ({
          ...provided,
          height: '35px',
        }),
      };


    const tableColumns = [
        { id: "1", label: "#" },
        { id: "2", label: "Date" },
        { id: "3", label: "Heure" },
        { id: "4", label: "Action" },
        { id: "5", label: "Utilisateur" },
        { id: "6", label: "Etablissement" }
    ]

    const loadLogs = async () => {
        const log_list_response = await getLogsAndParams(states.userToken.access_token, pageNumber);


        //  let log_list_response_copy = log_list_response.data?.journal?.map(obj => ({ ...obj, showEdit: false, showDelete: false }))
        const institutionsData = [];
        institutionsData.push({ value: "all", label: "Tous" })
        log_list_response.data.institutions?.map(value => institutionsData.push(({
            value: value.id,
            label: value.libelle
        })))

        const usersData = [];
        usersData.push({ value: "all", label: "Tous" })
        log_list_response.data.users?.map(value => (usersData.push({
            value: value.id,
            label: value.prenom + " " + value.nom
        })))

        setUsers(usersData)
        setInstitutions(institutionsData)
        console.log(log_list_response?.data?.journal.data)
        const total = log_list_response?.data?.journal?.total;
        const perPageValue = log_list_response?.data?.journal?.per_page
        setTotalPage(Math.ceil(total / perPageValue))
        setPerPage(perPageValue)
        dispatch({
            type: "SET",
            key: "logList",
            payload: log_list_response.data.journal.data,
        });
        setDisplayLoader(false);
        console.log(log_list_response)
        console.log(states.logList)
    }

    useEffect(() => {
        handleApplyFilter("no-filter")
    }, [pageNumber])

    useEffect(() => {
        loadLogs()
       
    }, [])

    const handleSelection = (key, e) => {
        let selectedValue = e.currentTarget?.value;
        if (key === "user") {
            var el = document.getElementById('user');
            var text = el.options[el.selectedIndex].innerHTML
            //   setLogParams({ ...logParams, user: { value: e.value, label: e.label } })
            setLogParams({ ...logParams, user: { value: selectedValue, label: text } })
        }
        if (key === "action") {
            var el = document.getElementById('action');
            var text = el.options[el.selectedIndex].innerHTML
            setLogParams({ ...logParams, action: { value: selectedValue, label: text } })
        }
        if (key === "institution") {
            var el = document.getElementById('institution');
            var text = el.options[el.selectedIndex].innerHTML
            setLogParams({ ...logParams, institution: { value: selectedValue, label: text } })
        }
    }


    const handleApplyFilter = async (type) => {
        if(type == "filter"){
            setPageNumber(1)
        }
        const { institution, user, action } = logParams;
        const debDay = dateRange[0]?.getDate();
        const finDay = dateRange[1]?.getDate();
        const debMonth = dateRange[0]?.getMonth() + 1;
        const finMonth = dateRange[1]?.getMonth() + 1;
        console.log("logs data deb", debDay)
        console.log("logs data fin", finDay)
        const dateDebut = dateRange[0]?.getFullYear() + "-" + (debMonth < 10 ? "0" + debMonth : debMonth) + "-" + (debDay < 10 ? "0" + debDay : debDay);
        const dateFin = dateRange[1]?.getFullYear() + "-" + (finMonth < 10 ? "0" + finMonth : finMonth) + "-" + (finDay < 10 ? "0" + finDay : finDay);

        const data = {
            "institution": institution.value == undefined || institution.value == "all" ? "" : institution.value,
            "action": action.value == undefined || action.value == "all" ? "" : action.value,
            "user": user.value == undefined || user.value == "all" ? "" : user.value,
            "debut": dateDebut !== "undefined-NaN-undefined" ? dateDebut : "",
            "fin": dateFin !== "undefined-NaN-undefined" ? dateFin : ""
        }

        console.log("logs data ", data);
        var log_list_response = await getLogs(states.userToken.access_token, data, pageNumber);
        console.log(log_list_response.data.data)
        const total = log_list_response?.data?.total;
        const perPageValue = log_list_response?.data?.per_page
        setTotalPage(Math.ceil(total / perPageValue))
        setPerPage(perPageValue)
        dispatch({
            type: "SET",
            key: "logList",
            payload: log_list_response?.data.data,
        });
        setDisplayLoader(false);

    }

    const changePage = ({ selected }) => {
        let currentPage = selected + 1;
        setPageNumber(currentPage)
    }

    return (
        <div>
            <Navbar />
            <div className="main-container" id="container">
                <Sidebar />

                <div id="content" className="main-content">
                    {displayLoader == false ?
                        <div className="layout-px-spacing">

                            <div className="row layout-top-spacing">
                                <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                                </div>
                            </div>

                            <h2 className="mb-3 text-left">Journal des évènements</h2>
                            <div className="widget widget-content widget-content-area p-3 mb-3">
                                <h5 className="text-left"> <FiFilter className="pb-1 mr-1" /> Filtres</h5>
                                <hr />
                                <div className="d-flex justify-content-between flex-wrap">
                                    <div className={"col-sm-4 col-xs-12 mb-3"}>
                                        <div>Etablissement</div>
                                        <select id="institution" onChange={(e) => handleSelection("institution", e)} className={"form-control custom-form-control basic mb-2"}>
                                            <option disabled selected hidden value=""> </option>
                                            {institutions !== [] && institutions?.map((item) => (
                                                <option key={item.value} value={item.value}>{item.label}</option>
                                            ))}
                                        </select>
                                        </div>
                                        <div className={"col-sm-4 col-xs-12 mb-3"}>
                                            <div>Utilisateur</div>
                                            <select id="user" onChange={(e) => handleSelection("user", e)} className={"form-control custom-form-control basic mb-2"}>
                                                <option disabled selected hidden value=""> </option>
                                                {users !== [] && users?.map((item) => (
                                                    <option key={item.value} value={item.value}>{item.label}</option>
                                                ))}
                                            </select>
                                        </div>
                                     
                                        <div className={"col-sm-3 col-xs-12 mb-3"}>
                                            <div>Actions</div>
                                            <select id="action" onChange={(e) => handleSelection("action", e)} className={"form-control custom-form-control basic mb-2"}>
                                                <option disabled selected hidden value="">Actions</option>
                                                {actions !== [] && actions?.map((item) => (
                                                    <option value={item.value}>{item.label}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-sm-4 col-xs-12 mb-3">
                                            <div className='truncate'>Mois(Début) - Mois(Fin)</div>
                                            <DatePicker
                                                selectsRange={true}
                                                startDate={startDate}
                                                endDate={endDate}
                                                dateFormat="dd/MM/yyyy"
                                                locale="fr"
                                                onChange={(update) => {
                                                    setDateRange(update);
                                                }}
                                                isClearable={true}
                                                placeholderText=""
                                                // showMonthYearPicker
                                                // showFullMonthYearPicker
                                                maxDate={new Date()}
                                                className={"form-control custom-form-control basic "}
                                                onChangeRaw={(e) => e.preventDefault()}
                                            />
                                        </div>
                                        <div className="col-sm-4 col-xs-12 mb-3 d-flex align-items-end">

                                            <button style={{ height: "35px", width: "100%" }} className="btn btn-dark" onClick={() => handleApplyFilter("filter")}>Appliquer</button>
                                        </div>
                                        <div className="col-sm-3 col-xs-12 mb-2">
                                        </div>
                                    </div>
                                </div>



                                <div className="widget widget-content widget-content-area  pb-3 mb-3">
                                    <h5 className="text-left p-3"> <FaClipboardList className="pb-1 mr-2" />Liste des évènements</h5>
                                    <p className="suivi-taux-total-number text-gray text-left pl-3">{states.logList?.length <= 1 ? `${states.logList?.length} élément` : states.logList?.length > 1 ? `${states.logList?.length} éléments` : `0 élément`}</p>
                                    {/* Start Custom Datatable */}

                                    {states.logList && states.logList.length != 0 ?
                                        <CustomDatatableJournal
                                            columns={tableColumns}
                                            data={states.logList}
                                            changePage={changePage}
                                            pageCount={totalPage}
                                            pageNumber={pageNumber}
                                            perPage={perPage}
                                        /> : <h4 className="py-3">Aucun résultat</h4>}

                                    {/* End Custom Datatable */}
                                </div>

                            </div> : <div style={{ marginTop: "25%" }}>
                                <Loader />
                            </div>}


                        </div>
                        </div>
            </div>
            )
}

            export default Journal